"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _LoadingBar = _interopRequireDefault(require("./LoadingBar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Status = _styledComponents.default.span.withConfig({
  displayName: "Status"
})(["font-family:", ";font-size:14px;font-weight:", ";line-height:120%;text-align:center;text-transform:capitalize;color:#646464;margin-top:1.8vh;@media (max-width:768px){display:", ";margin-top:0;margin-left:2vw;text-align:justify;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.font;
}, function (_ref2) {
  var active = _ref2.active;
  return active ? '500' : 'initial';
}, function (_ref3) {
  var active = _ref3.active;
  return active ? 'inline' : 'none';
});

var ClaimStatus = function ClaimStatus(_ref4) {
  var className = _ref4.className,
      active = _ref4.active,
      counter = _ref4.counter,
      stage = _ref4.stage;
  return /*#__PURE__*/_react.default.createElement(Status, {
    className: className,
    active: active
  }, counter, ". ", stage.name);
};

var ProgressBar = function ProgressBar(_ref5) {
  var activeId = _ref5.activeId,
      background = _ref5.background,
      filledColor = _ref5.filledColor,
      className = _ref5.className,
      height = _ref5.height,
      stages = _ref5.stages,
      stepsLength = _ref5.stepsLength,
      otherProps = _objectWithoutProperties(_ref5, ["activeId", "background", "filledColor", "className", "height", "stages", "stepsLength"]);

  return /*#__PURE__*/_react.default.createElement(StyledProgressBar, _extends({}, otherProps, {
    className: className
  }), /*#__PURE__*/_react.default.createElement(_LoadingBar.default, {
    stagesLength: stepsLength || stages.length,
    activeId: activeId,
    background: background,
    filledColor: filledColor,
    height: height
  }), stages.map(function (stage, i) {
    return /*#__PURE__*/_react.default.createElement(ClaimStatus, {
      key: stage.id,
      stage: stage,
      stages: stages,
      active: activeId === stage.id,
      counter: i + 1
    });
  }));
};

var StyledProgressBar = _styledComponents.default.div.withConfig({
  displayName: "StyledProgressBar"
})(["display:flex;justify-content:space-around;margin:4vh auto 0.55vh;position:relative;width:100%;@media (max-width:768px){margin:0;width:initial;}"]);

ProgressBar.defaultProps = {
  activeId: 1,
  height: '7px',
  otherProps: {},
  stages: [{
    key: 'start',
    name: 'start',
    id: 1
  }, {
    key: 'middle',
    name: 'middle',
    id: 2
  }, {
    key: 'end',
    name: 'end',
    id: 3
  }]
};
ProgressBar.propTypes = {
  activeId: _propTypes.number,
  background: _propTypes.string,
  className: _propTypes.string,
  filledColor: _propTypes.string,
  height: _propTypes.string,
  otherProps: _propTypes.object,
  stages: (0, _propTypes.arrayOf)(_propTypes.object),
  stepsLength: _propTypes.number
};
var _default = ProgressBar;
exports.default = _default;